<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="title"
    @shown="focusTitle"
  >
    <WorkflowForm
      v-if="formType === 'workflow'"
      :type="type"
      :gridId="gridId"
      :rowIndex="rowIndex"
      :sectionIndex="sectionIndex"
      @submitted="close()"
    />
    <RegularForm
      v-if="formType === 'regular'"
      :type="type"
      :gridId="gridId"
      :rowIndex="rowIndex"
      :sectionIndex="sectionIndex"
      @submitted="close()"
    />
    <LookUpFrom
      v-if="formType === 'lookup'"
      :type="type"
      :gridId="gridId"
      :rowIndex="rowIndex"
      :sectionIndex="sectionIndex"
      @submitted="close()"
    />
    <DataGridForm
      v-if="formType === 'datagrid'"
      :type="type"
      :gridId="gridId"
      :rowIndex="rowIndex"
      :sectionIndex="sectionIndex"
      @submitted="close()"
    />
  </b-modal>
</template>

<script>
// components
import WorkflowForm from './forms/WorkflowForm'
import RegularForm from './forms/RegularForm'
import LookUpFrom from './forms/LookUpForm'
import DataGridForm from './forms/DataGridForm'

export default {
  props: [
    'gridId',
    'rowIndex',
    'sectionIndex'
  ],
  components: {
    RegularForm,
    LookUpFrom,
    DataGridForm,
    WorkflowForm
  },
  data () {
    return {
      type: null
    }
  },
  computed: {
    title () {
      if (!this.type) return ''
      let title

      switch (this.type) {
        case 'string': title = 'Add "Text" type column'
          break
        case 'lookup': title = 'Add "Look Up" type column'
          break
        case 'multi_lookup': title = 'Add "Multi Look Up" type column'
          break
        case 'date': title = 'Add "Date" type column'
          break
        case 'files': title = 'Add "Files" type column'
          break
        case 'custom': title = 'Add "Custom Code" type column'
          break
        case 'checkbox': title = 'Add "Checkbox" type column'
          break
        case 'user': title = 'Add "User" type column'
          break
        case 'multiline_text': title = 'Add "Multiline Text" type column'
          break
        case 'profile_image': title = 'Add "Profile Image" type column'
          break
        case 'datagrid': title = 'Add "DataGrid" type column'
          break
        case 'select': title = 'Add "Select" type column'
          break
        case 'number': title = 'Add "Number" type column'
          break
        case 'workflow': title = 'Add "Workflow" type column'
          break
        case 'text_editor': title = 'Add "Text Editor" type column'
          break
        case 'qrScan': title = 'Add "QR Scan" type column'
          break
      }

      return title
    },
    formType () {
      if (this.type === 'lookup') return 'lookup'
      if (this.type === 'multi_lookup') return 'lookup'
      if (this.type === 'datagrid') return 'datagrid'
      if (this.type === 'workflow') return 'workflow'

      return 'regular'
    }
  },
  methods: {
    open (type) {
      this.type = type

      if (this.$refs.modal) this.$refs.modal.show()
    },
    close () {
      if (this.$refs.modal) this.$refs.modal.hide()
      this.$emit('columnAdded')
    },
    focusTitle() {
      $(this.$refs.modal.$refs.body).find('input[name="title"]').focus()
    }
  }
}
</script>
